
/**
 * @function getCurrentDeviceLocale Retrieves the current device's locale (language) from the browser and returns it
 */
export function getCurrentDeviceLocale(): string {
  const currentDeviceLocale: string = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;

  return currentDeviceLocale;
}
